import React from 'react';
import { ScoreCell } from 'components/scores';

const LeaderboardCellTotal = ({ data }) => {
    return (
        <div className="leaderboard__cell leaderboard__cell--today">
            <div className="leaderboard__cell-content">
                <ScoreCell
                    childCss='leaderboard__score-cell leaderboard__score-cell--wide'
                    bemList={['default', 'has-border']}
                >{data.total || '-'}</ScoreCell>
            </div>
        </div>
    );
};

export default LeaderboardCellTotal;
